import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { CHG_ACCT_MCH_UUID, CHG_ACCT_MCH_BASE, CHG_ACCT_MCH_SEL, CHG_ACCT_MCH_FILE, CHG_ACCT_MCH_RECKEY, CHG_ACCT_MCH_CANCEL } from '../../../store/types'
export const promptOnExitMixin = {
  data() {
    return {
      routeTo: undefined,
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doMatchExit() {
      this.unlockRecord(this.baseRecKey, 'ACT')
      this.skipPrompt = true
      this.$store.commit(CHG_ACCT_MCH_RECKEY, '')
      this.$store.commit(CHG_ACCT_MCH_BASE, false)
      this.$store.commit(CHG_ACCT_MCH_SEL, false)
      this.$store.commit(CHG_ACCT_MCH_UUID, null)
      this.$store.commit(CHG_ACCT_MCH_FILE, '')
      if (this.isCancel) {
        this.doExit()
      } else {
        this.$router.push(this.routeTo.path)
      }
      this.$store.commit(CHG_ACCT_MCH_CANCEL, false)
    }
  },
  // If user tries to leave this page, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (this.baseFromMatch) {
      if (!this.skipPrompt) {
        this.routeTo = to
        this.promptLeave = true
        next(false)
      } else {
        next()
      }
    } else {
      next()
    }
  },
  created() {
    this.$root.$on('promptOnExitMixin', () => {
      this.doExit()
    })
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  computed: {
    isUpload() {
      return this.$store.state.accounts.acctMchObj.isUpload
    }
  },
  mixins: [recordLockMixin],
  beforeDestroy() {
    this.$root.$off('promptOnExitMixin')
  }
}
